import React from 'react'

export const NotFound = () => {
    return (
        <div className="notFound">
            <div className="notFound--div">
                <h2>ERROR</h2>
                <h1>404</h1>
                <p>Página no encontrada</p>
                <div className="separator--hor mt-half mb-half"></div>
            </div>
        </div>
    )
}
